import React, { Component, ReactElement, ReactNode } from 'react';

import { arrayOf, element, oneOfType, string } from 'prop-types';

import { classNames } from '@philips-emr/tws-utils';

export interface SlideUpPanelFooterProps {
  children: ReactNode | ReactNode[];
  className?: string;
}

export default class SlideUpPanelFooter extends Component<SlideUpPanelFooterProps> {

  static propTypes = {
    children: oneOfType([element, arrayOf(element)]),
    className: string,
  };

  getClassNames(): string {
    const { className } = this.props;

    return classNames({
      'c-slide-up-panel__footer': true,
      [`${className}`]: Boolean(className),
    });
  }

  render(): ReactElement {
    const { children } = this.props;

    return (
      <div className={this.getClassNames()}>
        {children}
      </div>
    );
  }
}
